import React, { Component } from 'react';
import { connect } from 'react-redux';

import { logoutRequested } from '../actions';

import Header from '../components/Header.jsx';

@connect(undefined, { logoutRequested })
export default class HeaderContainer extends Component {
  render() {
    return (
      <Header {...this.props} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Header.jsx